module.exports = __webpack_public_path__ + "badge-comment.svg?be8760e39638ca9a1c816e1b0b8d2845";


//////////////////
// WEBPACK FOOTER
// ./public/images/site/badge-comment.svg
// module id = 479
// module chunks = 0